import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const emrEvaluationApi = createApi({
  baseQuery,
  reducerPath: 'EMREvaluationApi',
  endpoints: builder => ({
    getAllEMREvalutions: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country, application, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}
          `,
        method: 'POST',
        body: data
      })
    }),

    getSiteEMREvalutions: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, event_id }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.getSite,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.event_id, value: event_id }
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}
          `,
        method: 'GET'
      })
    }),

    getSponsorEMREvalutions: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, event_id }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.getSponsor,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.event_id, value: event_id }
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}
          `,
        method: 'GET'
      })
    }),
    createEMREvaluationDataForSite: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.createSite,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),
    createEMREvaluationDataForSponsor: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.createSponsor,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),
    updateEMREvaluationDataForSite: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.updateSite,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=TSDA&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),

    updateEMREvaluationDataForSponsor: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.updateSponsor,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=CTMS&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),

    sponsorSign: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, site, data, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.sponsorSign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),

    siteSign: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.siteSign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?country=${country}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),

    publishToETMF: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, emr_id, update, is_published, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.PublishToETMF,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&emr_id=${emr_id}&update=${update}&is_published=${is_published}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),

    publishToISF: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, id, update, is_published, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.publishToISF,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&id=${id}&update=${update}&is_published=${is_published}&application=${application}&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),
    createNewEMRversion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.createNewEMRversion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country }
        )}?application=${application}&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),
    newEMRversion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, emr_id }) => ({
        url: `${formatString(
          endPoints.EMREvaluation.newEMRVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.emr_id, value: emr_id }
        )}?application=${application}&application_module_section=STUDY LOGS`,
        method: 'PUT'
      })
    })
  })
});

export const {
  useGetAllEMREvalutionsMutation,
  useLazyGetSiteEMREvalutionsQuery,
  useLazyGetSponsorEMREvalutionsQuery,
  useCreateEMREvaluationDataForSiteMutation,
  useUpdateEMREvaluationDataForSiteMutation,
  useUpdateEMREvaluationDataForSponsorMutation,
  useSiteSignMutation,
  useSponsorSignMutation,
  usePublishToETMFMutation,
  usePublishToISFMutation,
  useCreateNewEMRversionMutation,
  useCreateEMREvaluationDataForSponsorMutation,
  useNewEMRversionMutation
} = emrEvaluationApi;
